// calculation value based on css style
const WRAPPER_WIDTH = 632;
const MAX_CHIP_WIDTH = 110;
const CHAR_WIDTH = 6;
const GAP = 6;

export const getChipWidth = (label: string) => {
  return Math.min(34 + CHAR_WIDTH * label.length, MAX_CHIP_WIDTH);
};

export const calculateVisibleCount = (labels: string[]) => {
  let used = 0;
  let count = 0;

  const overflowReserve = 60 + GAP; // "+N" chip

  for (let i = 0; i < labels.length; i++) {
    const chipWidth = getChipWidth(labels[i]);

    const next = used + chipWidth + (count > 0 ? GAP : 0);

    const remaining = labels.length - i - 1;
    const reserve = remaining > 0 ? overflowReserve : 0;

    if (next + reserve > WRAPPER_WIDTH) break;

    used = next;
    count++;
  }

  return count;
};
